import React, { useCallback, useState } from 'react'
import { FormValues } from 'donate/types'
import { Modal } from 'shared'
import { connect } from 'formik'
import { postMessageScrollTop } from 'shared'

export const Terms = () => (
  <div className="donations-form-terms-of-use">{i18n.locale === 'de' ? <TermsDE /> : <TermsEN />}</div>
)

const TermsDE = () => (
  <>
    <span>Es gelten die </span>
    <TermsLink />
    <span> und </span>
    <PrivacyLink />
    <BetterplaceInfo />
    <SEPAMandateLink />
    <span>.</span>
  </>
)

const TermsEN = () => (
  <>
    <span>The </span>
    <TermsLink />
    <span> and </span>
    <PrivacyLink />
    <BetterplaceInfo />
    <SEPAMandateLink />
    <span> apply.</span>
  </>
)

const TermsLink = () => (
  <a target="_blank" className="larger-click-area" href={i18n.t('donate.terms.terms_url')} rel="noreferrer">
    {i18n.t('donate.terms.terms_label')}
  </a>
)

const PrivacyLink = () => (
  <a target="_blank" className="larger-click-area" href={i18n.t('donate.terms.privacy_url')} rel="noreferrer">
    {i18n.t('donate.terms.privacy_label')}
  </a>
)

const BetterplaceInfo = connect<{}, FormValues>(({ formik }) => {
  const [showModal, setShowModal] = useState(false)
  const hideModal = useCallback(() => {
    setShowModal(false)
  }, [])
  const openModal = useCallback(() => {
    setShowModal(true)
  }, [])

  return (
    <>
      {' '}
      <span>
        {i18n.t(`donate.terms.${formik.values.channel === 'iframe' ? 'iframe' : 'default'}_recipient_info`)}
      </span>{' '}
      <button type="button" className="simulated-link" onClick={openModal}>
        {i18n.t('donate.terms.default_recipient_name')}
      </button>{' '}
      <span>(gut.org gAG)</span>
      <Modal
        id="betterplace-info-modal"
        onHide={hideModal}
        onShow={postMessageScrollTop}
        show={showModal}
        header={i18n.t('donate.terms.recipient_info_modal_headline')}
        footer={
          <button className="my-1 btn btn-primary" onClick={hideModal} type="button">
            {i18n.t('donate.codonation_selection.why_modal.close_button')}
          </button>
        }
      >
        <span>{i18n.t('donate.terms.recipient_info_modal_text')}</span>
        <br />
        <a href={i18n.t('donate.terms.gut_org_help_url')} target="_blank" rel="noreferrer">
          {i18n.t('donate.terms.recipient_info_read_more_label')}
        </a>
      </Modal>
    </>
  )
})

const SEPAMandateLink = connect<{}, FormValues>(({ formik }) => {
  if (formik.values.payment_method !== 'stripe_sepa_debit') return null

  const [showModal, setShowModal] = useState(false)
  const hideModal = useCallback(() => {
    setShowModal(false)
  }, [])
  const openModal = useCallback(() => {
    setShowModal(true)
  }, [])

  return (
    <>
      {' '}
      <span>{i18n.t('donate.terms.sepa_prefix')}</span>{' '}
      <button type="button" className="simulated-link larger-click-area" onClick={openModal}>
        {i18n.t('donate.terms.sepa_mandate_label')}
      </button>
      <Modal
        id="sepa-mandate-modal"
        onHide={hideModal}
        onShow={postMessageScrollTop}
        show={showModal}
        header={i18n.t('donate.terms.sepa_mandate_label')}
        footer={
          <button className="my-1 btn btn-primary" onClick={hideModal} type="button">
            {i18n.t('donate.codonation_selection.why_modal.close_button')}
          </button>
        }
      >
        {SEPA_MANDATE_DISCLAIMER[i18n.locale] || SEPA_MANDATE_DISCLAIMER['en']}
      </Modal>
    </>
  )
})

// disclaimer as required by Stripe:
// https://stripe.com/docs/payments/sepa-debit/accept-a-payment
// translations:
// https://www.europeanpaymentscouncil.eu/other/core-sdd-mandate-translations
const SEPA_MANDATE_DISCLAIMER: Record<string, string> = {
  de: 'Ich ermächtige/Wir ermächtigen (A) gut.org gAG und den Zahlungsdienstleister Stripe, Zahlungen von meinem/unserem Konto mittels Lastschrift einzuziehen. Zugleich (B) weise ich mein/weisen wir unser Kreditinstitut an, die von gut.org gAG auf mein/unser Konto gezogenen Lastschriften einzulösen. Hinweis: Ich kann/Wir können innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem/unserem Kreditinstitut vereinbarten Bedingungen.',
  en: 'By providing your IBAN and confirming this payment, you authorise (A) gut.org gAG and Stripe, our payment service provider, to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with those instructions. You are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within eight weeks starting from the date on which your account was debited.',
}
